<template>
  <el-select
    v-model="computedValue"
    placeholder="请选择（多选）"
    clearable
    multiple
    style="width: 350px"
    :disabled="!editable"
  >
    <el-option
      v-for="item in config.options"
      :key="item.baseQuestionOptionId"
      :label="item.baseQuestionOptionName"
      :value="String(item.baseQuestionOptionId)"
    >
    </el-option>
  </el-select>
</template>

<script>
import CompMix from "../../mixins/comp-mix";
export default {
  mixins: [CompMix],
  props: {
    // v-model传入的值
    value: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped></style>
